exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header-picker{display:none!important}", "", {"version":3,"sources":["/app/src/components/master/buyingTariff/OverriddenGeneralSurcharge.vue"],"names":[],"mappings":"AACA,eACE,sBAAyB,CAC1B","file":"OverriddenGeneralSurcharge.vue","sourcesContent":["\n.header-picker {\n  display: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f38d084","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/buyingTariff/OverriddenGeneralSurcharge.vue
// module id = 991
// module chunks = 16